<app-kontable
    #closedReservationTable
    title="{{ 'reservations.closedReservations' | translate }}"
    [columns]="[
      {field: 'num_reservation', title: 'reservations.reservationNumber'},
      {field: 'dt_reservation', title: 'reservations.reservationDate', type: 'date', filterType: dateFilter},
      {field: 'gift_code', title: 'reservations.gift', bodyTemplate: giftTemplate},
      {field: 'points', title: 'reservations.points'},
      {field: 'value', title: 'reservations.value', bodyTemplate: contribution},
      {field: 'status', title: 'reservations.status'},
      {field: 'gift_type', title: 'reservations.giftType'},
      {field: 'dt_annull', title: 'reservations.cancellationDate', type: 'date', filterType: dateFilter},
      {field: 'dt_confirm', title: 'reservations.confirmationDate', type: 'date', filterType: dateFilter},
      {field: 'dt_ret', title: 'reservations.pickupDate', type: 'date', filterType: dateFilter},
      {field: 'store_desc', title: 'common.store_title', bodyTemplate: storeTemplate},
      {field: 'pickup_store_desc', title: 'reservations.pickupStore', bodyTemplate: pickupStoreTemplate}
    ]"
    [source]="reservations"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="true"
    [showGlobalFilter]="false"
    [additionalRowCommands]="customRow"
  >

    <!-- Custom Buttons -->
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Button Visualizzazione Dettagli Prenotazione -->
      <p-button pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="onShowDetails.emit(row)"></p-button>
    </ng-template>
    <!-- Template Negozio -->
    <ng-template #storeTemplate data-testid="storeTemplate" let-row>
      <span>{{ row.store_code }} - {{ row.store_desc }}</span>
    </ng-template>
    <!-- Template Negozio Ritiro -->
    <ng-template #pickupStoreTemplate data-testid="pickupStoreTemplate" let-row>
      <span>{{ row.pickup_store_host_code }} - {{ row.pickup_store_desc }}</span>
    </ng-template>
    <!-- Template Premio -->
    <ng-template #giftTemplate data-testid="giftTemplate" let-row>
      <span>{{ row.gift_code }} - {{ row.gift_description }}</span>
    </ng-template>
     <!-- Template contributo-->
     <ng-template #contribution data-testid="contribution" let-row>
      <span *ngIf="row.value">{{row.value.toFixed(2)  + "€"}}</span>
    </ng-template>
  </app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-closed-reservations/loyalty-closed-reservations.component.html